import { render, staticRenderFns } from "./ZenifyIndex.vue?vue&type=template&id=86345478"
import script from "./ZenifyIndex.vue?vue&type=script&lang=js"
export * from "./ZenifyIndex.vue?vue&type=script&lang=js"
import style0 from "./ZenifyIndex.vue?vue&type=style&index=0&id=86345478&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports